"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var player_react_google_maps_1 = require("player-react-google-maps");
var withScriptjs = require("player-react-google-maps/lib/async/withScriptjs");
require("./GoogleMaps.css");
var player_preloader_1 = require("player-preloader");
var InfoWindow_1 = require("./InfoWindow");
var AsyncGoogleMap = withScriptjs['default'](
/* istanbul ignore next */
player_react_google_maps_1.withGoogleMap(function (props) { return (React.createElement(player_react_google_maps_1.GoogleMap, { ref: props.onMapLoad, defaultZoom: props.defaultZoom, center: { lat: props.centerLat, lng: props.centerLng }, onBoundsChanged: props.onBoundsChanged }, props.markers.length > 0 && props.markers.map(function (marker) { return (React.createElement(player_react_google_maps_1.Marker, __assign({}, marker, { key: marker.id, position: marker.position, onClick: function () { return props.onMarkerClick(marker); } }), marker.showInfo && (React.createElement(player_react_google_maps_1.InfoWindow, { onCloseClick: function () { return props.onMarkerClose(marker); } },
    React.createElement("div", { onClick: function () { return props.onInfoWindowClick(marker); } }, marker.content))))); }))); }));
var GoogleMaps = (function (_super) {
    __extends(GoogleMaps, _super);
    function GoogleMaps(props) {
        var _this = _super.call(this, props) || this;
        _this._handleMarkerClick = _this._handleMarkerClick.bind(_this);
        _this._handleMapLoad = _this._handleMapLoad.bind(_this);
        _this.state = {
            markers: []
        };
        return _this;
    }
    GoogleMaps.prototype.componentDidMount = function () {
        var _a = this.props, markers = _a.markers, onInfoWindowClick = _a.onInfoWindowClick, iconSrc = _a.iconSrc, headerColor = _a.headerColor, headerSize = _a.headerSize, subheaderSize = _a.subheaderSize, descriptionSize = _a.descriptionSize, selectedMarkerId = _a.selectedMarkerId, selectedMarkerIconSrc = _a.selectedMarkerIconSrc;
        /* istanbul ignore next */
        this.setState({
            markers: markers ? markers.map(function (marker) {
                if (selectedMarkerId && selectedMarkerId === marker.id) {
                    return __assign({}, marker, { position: { lat: marker.lat, lng: marker.lng }, icon: selectedMarkerIconSrc, showInfo: true, content: (React.createElement(InfoWindow_1.default, { headerText: marker.headerText, subheaderText: marker.subheaderText, description: marker.description, headerColor: headerColor, headerSize: headerSize, subheaderSize: subheaderSize, descriptionSize: descriptionSize, isClickable: onInfoWindowClick ? true : false })) });
                }
                else {
                    return __assign({}, marker, { position: { lat: marker.lat, lng: marker.lng }, icon: iconSrc, content: (React.createElement(InfoWindow_1.default, { headerText: marker.headerText, subheaderText: marker.subheaderText, description: marker.description, headerColor: headerColor, headerSize: headerSize, subheaderSize: subheaderSize, descriptionSize: descriptionSize, isClickable: onInfoWindowClick ? true : false })) });
                }
            }) : []
        });
    };
    // set a ref of the map in the component
    /* istanbul ignore next */
    GoogleMaps.prototype._handleMapLoad = function (map) {
        this._mapComponent = map;
        return map;
    };
    /* istanbul ignore next */
    // open targeted infoWindow, close all others
    GoogleMaps.prototype._handleMarkerClick = function (targetMarker) {
        var _a = this.props, selectedMarkerIconSrc = _a.selectedMarkerIconSrc, selectedMarkerId = _a.selectedMarkerId, iconSrc = _a.iconSrc;
        this.setState({
            markers: this.state.markers.map(function (marker) {
                if (marker === targetMarker) {
                    // if map is on job details page, newly clicked markers should not have highlighted icon
                    if (selectedMarkerId) {
                        return __assign({}, marker, { showInfo: true });
                        // if no selectedMarkerId (ie map is on job search page), newly clicked markers can be highlighted
                    }
                    else {
                        return __assign({}, marker, { showInfo: true, icon: selectedMarkerIconSrc });
                    }
                }
                else {
                    // hide all other open info windows
                    if (selectedMarkerId) {
                        return __assign({}, marker, { showInfo: false });
                    }
                    else {
                        return __assign({}, marker, { showInfo: false, icon: iconSrc });
                    }
                }
            }),
        });
    };
    /* istanbul ignore next */
    // hide infoWindow when X is clicked
    GoogleMaps.prototype._handleMarkerClose = function (targetMarker) {
        var _a = this.props, iconSrc = _a.iconSrc, selectedMarkerId = _a.selectedMarkerId;
        this.setState({
            markers: this.state.markers.map(function (marker) {
                if (marker === targetMarker) {
                    // on marker close return icon to default state
                    if (selectedMarkerId && selectedMarkerId === marker.id) {
                        return __assign({}, marker, { showInfo: false });
                    }
                    else {
                        return __assign({}, marker, { showInfo: false, icon: iconSrc });
                    }
                }
                return marker;
            }),
        });
    };
    GoogleMaps.prototype._getSizeValues = function (size) {
        var cases = {
            'Xsmall': 'xs',
            'Small': 'sm',
            'Medium': 'md',
            'Large': 'lg',
            'Xlarge': 'xl',
            'Auto': 'fh'
        };
        return 'p-gm-sz-' + cases[size];
    };
    GoogleMaps.prototype.render = function () {
        var _this = this;
        var _a = this.props, tag = _a.tag, apiKey = _a.apiKey, onInfoWindowClick = _a.onInfoWindowClick, centerLat = _a.centerLat, centerLng = _a.centerLng, defaultZoom = _a.defaultZoom, loadingText = _a.loadingText, onBoundsChanged = _a.onBoundsChanged, mapSize = _a.mapSize;
        var markers = this.state.markers;
        var googleMapUrl = "https://maps.googleapis.com/maps/api/js?key=" + apiKey;
        var mapSizeTranslated = this._getSizeValues(mapSize);
        /* istanbul ignore next */
        return (React.createElement("div", { className: 'p-google-maps ' + mapSizeTranslated, "data-tag": tag, "aria-hidden": true, role: "presentation" },
            React.createElement(AsyncGoogleMap, { googleMapURL: googleMapUrl, centerLat: centerLat, centerLng: centerLng, defaultZoom: defaultZoom, loadingElement: React.createElement("div", { style: { height: '100%' } },
                    React.createElement(player_preloader_1.default, { isVisible: true }),
                    loadingText), containerElement: React.createElement("div", { style: { height: '100%' } }), mapElement: React.createElement("div", { style: { height: '100%' } }), markers: markers, onMapLoad: this._handleMapLoad, onMarkerClick: function (marker) { return _this._handleMarkerClick(marker); }, onMarkerClose: function (marker) { return _this._handleMarkerClose(marker); }, onInfoWindowClick: onInfoWindowClick ?
                    function (marker) { return onInfoWindowClick(marker); } :
                    function () { return; }, onBoundsChanged: onBoundsChanged ?
                    function () { return onBoundsChanged(); } :
                    function () { return; } })));
    };
    return GoogleMaps;
}(React.Component));
GoogleMaps.defaultProps = {
    defaultZoom: 3,
    centerLat: 34.028121,
    centerLng: -118.472665,
    markers: [],
    apiKey: '',
    loadingText: 'Loading Map...',
    mapSize: 'Medium'
};
exports.default = GoogleMaps;
//# sourceMappingURL=GoogleMaps.js.map


//////////////////
// WEBPACK FOOTER
// ../player-google-maps/build/control/GoogleMaps.js
// module id = 89
// module chunks = 0